import { motion } from 'framer-motion'
import styled from 'styled-components'

const InfoContainer = styled(motion.div)`
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%) translateZ(0);
  text-align: center;
  padding: 0 30px;
  max-width: 400px;
  z-index: 2;
  will-change: opacity, transform;
  backface-visibility: hidden;
`

const Title = styled.h3`
  font-size: 1.4rem;
  color: ${props => props.color || props.theme.colors.accent.yellow};
  margin-bottom: 15px;
  font-weight: 600;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  transform: translateZ(0);
`

const Description = styled.p`
  font-size: 1rem;
  line-height: 1.7;
  color: ${props => props.theme.colors.text.primary};
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  transform: translateZ(0);
`

const CharacterInfo = ({ character, isVisible }) => {
    return (
        <InfoContainer
            initial={{ opacity: 0, y: 30 }}
            animate={{
                opacity: isVisible ? 1 : 0,
                y: isVisible ? 0 : 30
            }}
            transition={{
                duration: 0.5,
                delay: isVisible ? 0.2 : 0,
                ease: [0.4, 0, 0.2, 1]
            }}
        >
            <Title color={character.mainColor}>
                {character.title}
            </Title>
            <Description>
                {character.description}
            </Description>
        </InfoContainer>
    )
}

export default CharacterInfo